import {CompanyIntelligence} from './CompanyIntelligence'
import {useCrmResource} from './lib/useCrmResource'
import {getCompanyProfile,type CompanyProfileSnapshot} from './lib/companyProfile'

/** The same canonical projection, bounded to this company before expensive checks. */
export function CompanyIntelligenceProfile({companyId}:{companyId:string}){
 const data=useCrmResource<CompanyProfileSnapshot>('company-profile-context',(_previous,context)=>getCompanyProfile(context,companyId),false,{companyId})
 const company=data.data?.companies?.find(record=>record.id===companyId)
 if(data.denied||data.error)return <p role="status">Company intelligence is unavailable. Refresh current company records.</p>
 if(!data.data)return <p role="status">Loading company intelligence.</p>
 return company?<CompanyIntelligence company={company}/>:<p>Company intelligence: Not recorded.</p>
}
